import React from 'react';
import classnames from 'classnames';

import { trackGA4AndNavigate } from '@gumtree/shared/src/util/ga4-shared';
import { getDomainFromUrl } from '@gumtree/shared/src/util/url-service';
import { Icon, SubMenu, SubMenuItem } from '@gumtree/ui-library';
import slug from '@gumtree/ui-library/src/utils/slug';
import { qaAttribute } from '@gumtree/ui-library/src/utils/qa-service';
import { useShowPayShipFeature } from '@gumtree/shared/src/hooks/useShowPayShipFeature';
import LinkButton from './link-button';
import getMenuItems from './user-sub-menu-data';
import LogoutForm from '../logout-form';

import './user-sub-menu.scss';

export default function UserSubMenu({
    isOpen = false,
    pageType,
}: {
    isOpen?: boolean;
    pageType: string;
}) {
    const showPayShipFeature = useShowPayShipFeature();
    const menuItems = React.useMemo(() => getMenuItems(showPayShipFeature), [showPayShipFeature]);

    return (
        <div
            data-testid="user-sub-menu"
            className={classnames({ 'user-sub-menu': true, open: isOpen })}
            {...qaAttribute('user-sub-menu')}
            suppressHydrationWarning
        >
            <SubMenu>
                {menuItems.map(({ label, url }) => (
                    <SubMenuItem key={label}>
                        <LinkButton
                            isPadded
                            url={url}
                            {...qaAttribute(`user-menu-link-${slug(label)}`)}
                            onClick={(e) => {
                                trackGA4AndNavigate<GA4.ClickPrimaryNavigation>({
                                    href: url,
                                    mouseEvent: e,
                                    payload: {
                                        event: 'click_primary_navigation',
                                        linkDomain: getDomainFromUrl(url),
                                        linkText: label,
                                        linkURL: url,
                                        navigationCategory: 'menu',
                                        navigationHeader: undefined,
                                        navigationHierarchy: 'sub header',
                                        pageClickedFrom: pageType,
                                    },
                                });
                            }}
                        >
                            {label}
                            <Icon type="chevron-r" />
                        </LinkButton>
                    </SubMenuItem>
                ))}
                <SubMenuItem>
                    <LogoutForm />
                </SubMenuItem>
            </SubMenu>
        </div>
    );
}
